import React from 'react';
import Icon from '../../../components/AppIcon';
import { Checkbox } from '../../../components/ui/Checkbox';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';

const AppPreferences = ({ preferences, onPreferenceChange }) => {
  const fileSizeOptions = [
    { value: '5', label: '5 MB', description: 'Small files only' },
    { value: '10', label: '10 MB', description: 'Standard limit' },
    { value: '25', label: '25 MB', description: 'Medium files' },
    { value: '50', label: '50 MB', description: 'Large files' },
    { value: '100', label: '100 MB', description: 'Very large files' }
  ];

  const fileTypeOptions = [
    { value: 'images', label: 'Images', description: 'JPG, PNG, GIF, WebP' },
    { value: 'documents', label: 'Documents', description: 'PDF, DOC, DOCX, TXT' },
    { value: 'videos', label: 'Videos', description: 'MP4, MOV, AVI' },
    { value: 'audio', label: 'Audio', description: 'MP3, WAV, OGG' },
    { value: 'archives', label: 'Archives', description: 'ZIP, RAR, TAR' }
  ];

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-base font-semibold text-foreground mb-4 flex items-center gap-2">
          <Icon name="Settings" size={18} />
          Upload Settings
        </h3>
        <div className="space-y-4">
          <Select
            label="Maximum File Size"
            description="Set the maximum allowed file size for uploads"
            options={fileSizeOptions}
            value={preferences?.maxFileSize}
            onChange={(value) => onPreferenceChange('maxFileSize', value)}
          />

          <Select
            label="Allowed File Types"
            description="Select which file types can be uploaded"
            options={fileTypeOptions}
            value={preferences?.allowedFileTypes}
            onChange={(value) => onPreferenceChange('allowedFileTypes', value)}
            multiple
            searchable
          />

          <Checkbox
            label="Auto-generate thumbnails"
            description="Automatically create thumbnails for uploaded images"
            checked={preferences?.autoThumbnails}
            onChange={(e) => onPreferenceChange('autoThumbnails', e?.target?.checked)}
          />

          <Checkbox
            label="Compress images on upload"
            description="Reduce image file sizes while maintaining quality"
            checked={preferences?.compressImages}
            onChange={(e) => onPreferenceChange('compressImages', e?.target?.checked)}
          />
        </div>
      </div>
      <div className="border-t border-border pt-6">
        <h3 className="text-base font-semibold text-foreground mb-4 flex items-center gap-2">
          <Icon name="Eye" size={18} />
          Preview Options
        </h3>
        <div className="space-y-4">
          <Checkbox
            label="Enable file previews"
            description="Show preview for supported file types"
            checked={preferences?.enablePreviews}
            onChange={(e) => onPreferenceChange('enablePreviews', e?.target?.checked)}
          />

          <Checkbox
            label="Show file metadata"
            description="Display detailed file information in previews"
            checked={preferences?.showMetadata}
            onChange={(e) => onPreferenceChange('showMetadata', e?.target?.checked)}
          />

          <Checkbox
            label="Enable grid view by default"
            description="Use grid layout instead of list view"
            checked={preferences?.defaultGridView}
            onChange={(e) => onPreferenceChange('defaultGridView', e?.target?.checked)}
          />
        </div>
      </div>
      <div className="border-t border-border pt-6">
        <h3 className="text-base font-semibold text-foreground mb-4 flex items-center gap-2">
          <Icon name="Zap" size={18} />
          Performance
        </h3>
        <div className="space-y-4">
          <Input
            label="Items per page"
            type="number"
            min="10"
            max="100"
            description="Number of files to display per page"
            value={preferences?.itemsPerPage}
            onChange={(e) => onPreferenceChange('itemsPerPage', e?.target?.value)}
          />

          <Checkbox
            label="Enable lazy loading"
            description="Load images as you scroll for better performance"
            checked={preferences?.lazyLoading}
            onChange={(e) => onPreferenceChange('lazyLoading', e?.target?.checked)}
          />

          <Checkbox
            label="Cache file listings"
            description="Store file lists locally for faster access"
            checked={preferences?.cacheListings}
            onChange={(e) => onPreferenceChange('cacheListings', e?.target?.checked)}
          />
        </div>
      </div>
    </div>
  );
};

export default AppPreferences;